// UID: NPO-HOA-BOD_ATB-FILE
// https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import MeetingMinutesRuleset from '../../business/ruleset/MeetingMinutesRuleset';

const { meetingMinutes } = loanFormModel.formField.hoaDocuments;

export class MeetingMinutesValidation implements ValidationSchema {
  public name = meetingMinutes.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public ruleset = MeetingMinutesRuleset;

  public when(schema: any, context: any, rulesetResult: RulesetResult) {
    const required = !!(rulesetResult & RulesetResult.REQUIRED);
    const fileSchema = FileNameValidationSchema(meetingMinutes.name, required);
    if (required) {
      return fileSchema.required('This document is required');
    }
    return fileSchema;
  }
}
export default new Validation(new MeetingMinutesValidation());
